"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EstamosATuDisposiciN() {
  const headlineWords = [{
    text: "La",
    italic: false
  }, {
    text: "excelencia",
    italic: false
  }, {
    text: "en",
    italic: false
  }, {
    text: "salud",
    italic: false
  }, {
    text: "capilar,",
    italic: true
  }, {
    text: "personalizada",
    italic: false
  }, {
    text: "para",
    italic: false
  }, {
    text: "ti.",
    italic: false
  }];
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.1
  });
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return;
}